import { formatPhoneInput, US_STATES } from 'shared';
import { Field } from '@/components/field.js';
import { Select } from '@/components/select.js';
import {
  customerFieldError as err,
  customerForm,
  updateCustomerForm as update,
} from '@/state/customer-form.js';

/** Same primitives, state and validation as the marketplace screen; only the chrome differs. */
export function OutreachCustomerInfoCard() {
  const form = customerForm.value;

  return (
    <div className="sm-panel sm-stack sm-animate-in sm-chat-tail sm-chat-form-card">
      <div className="sm-stack sm-section">
        <span className="sm-type-eyebrow">Contact</span>
        <div className="sm-row-2">
          <Field
            id="sm-chat-first-name"
            label="First name"
            value={form.firstName}
            error={err('firstName')}
            autoComplete="given-name"
            placeholder="Jane"
            onInput={(e) => update('firstName', (e.currentTarget as HTMLInputElement).value)}
          />
          <Field
            id="sm-chat-last-name"
            label="Last name"
            value={form.lastName}
            error={err('lastName')}
            autoComplete="family-name"
            placeholder="Doe"
            onInput={(e) => update('lastName', (e.currentTarget as HTMLInputElement).value)}
          />
        </div>
        <Field
          id="sm-chat-email"
          label="Email"
          value={form.email}
          error={err('email')}
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder="jane@example.com"
          onInput={(e) => update('email', (e.currentTarget as HTMLInputElement).value)}
        />
        <Field
          id="sm-chat-phone"
          label="Phone"
          value={form.phone}
          error={err('phone')}
          type="tel"
          inputMode="tel"
          autoComplete="tel-national"
          placeholder="(555) 123-4567"
          onInput={(e) =>
            update('phone', formatPhoneInput((e.currentTarget as HTMLInputElement).value))
          }
        />
      </div>

      <div className="sm-stack sm-section">
        <span className="sm-type-eyebrow">Address</span>
        <Field
          id="sm-chat-street1"
          label="Street address"
          value={form.street1}
          error={err('street1')}
          autoComplete="address-line1"
          placeholder="123 Main St"
          onInput={(e) => update('street1', (e.currentTarget as HTMLInputElement).value)}
        />
        <div className="sm-row-csz">
          <Field
            id="sm-chat-city"
            label="City"
            value={form.city}
            error={err('city')}
            autoComplete="address-level2"
            placeholder="Tampa"
            onInput={(e) => update('city', (e.currentTarget as HTMLInputElement).value)}
          />
          <Select
            id="sm-chat-state"
            label="State"
            placeholder="Select"
            options={US_STATES}
            value={form.state}
            error={err('state')}
            onChange={(e) => update('state', (e.currentTarget as HTMLSelectElement).value)}
          />
          <Field
            id="sm-chat-postal-code"
            label="ZIP"
            value={form.postalCode}
            error={err('postalCode')}
            inputMode="numeric"
            autoComplete="postal-code"
            placeholder="33602"
            maxLength={10}
            onInput={(e) => update('postalCode', (e.currentTarget as HTMLInputElement).value)}
          />
        </div>
      </div>
    </div>
  );
}
